module.exports = __webpack_public_path__ + "static/media/Conexao-EnsinoMed-curto.8a1556d5.png";